import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-message",
  "use": "icon-s-message-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-message\"><path d=\"M17 0a5 5 0 0 1 5 5v6.73a5 5 0 0 1-5 5H6.747L0 22 .031 4.99a5 5 0 0 1 5-4.99zm0 2H5.031a3 3 0 0 0-3 2.994l-.023 12.9 4.05-3.163H17a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3M7 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2m4 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m4 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol